import React from "react";
import { Link, useParams, useOutletContext } from "react-router-dom";
import MpgErrorDialog from "../../../../../common/dialog/MpgErrorDialog";
import EditProgrammeDescriptor from "./EditProgrammeDescriptor";
import { useGetProgrammeDescriptorByIdQuery } from "../../../../../reactQueries/AppApi/rqHooksForProgrammeDescriptor";

const EditProgrammeDescriptorHome = () => {
  let { id } = useParams();

  const {
    data: programDescriptorById,
    isError: isErrorOnPDById,
    isFetching: isFetchingOnPDById,
    isSuccess: isSuccessOnPDById,
    error: errorOnPDById,
  } = useGetProgrammeDescriptorByIdQuery({ programDescriptorId: id });

  const resourcesCMSData = useOutletContext();

  const fetchCommonCMSLabel = (key) => {
    if (resourcesCMSData && resourcesCMSData?.pageContent["CommonComponent"]) {
        const commonCMSDataLabel = resourcesCMSData.pageContent["CommonComponent"];
        return returnLabel(commonCMSDataLabel?.Labels, key)
    }
    return '';
  }

  const returnLabel = (labelArray, key) => {
    if (labelArray.length > 0 && key) {
        return labelArray.find((x) => x.Key === key)?.Phrase || '';
    }
    return '';
  }

  return (
    <div>
      {
        !!isFetchingOnPDById && fetchCommonCMSLabel ('Common.Waitloading') //"Wait, Loading...."
      }
      {!!isSuccessOnPDById && (
        <EditProgrammeDescriptor programDescriptorById={programDescriptorById} />
      )}

      <MpgErrorDialog
        open={!!isErrorOnPDById}
      />
    </div>
  );
};

export default EditProgrammeDescriptorHome;
